import { ChevronDown } from 'lucide-react';

import { Container } from '@/components/ui/container';
import { Section, SectionHeading } from '@/components/ui/section';
import { faqs, links } from '@/content/site';

const answerClassName =
  'pb-5 pr-9 text-sm leading-relaxed text-ink-500 [&_p:not(:first-child)]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-5 [&_li]:pl-1';

export function Faq() {
  return (
    <Section className="bg-white">
      <Container className="max-w-[1200px]">
        <SectionHeading
          eyebrow="FAQ"
          title="Common questions about Den wallets"
          align="left"
          className="items-center text-center sm:items-start sm:text-left"
        />
        <div className="mx-auto mt-12">
          {faqs.map(({ q, a }) => (
            <details
              key={q}
              name="wallet-faq"
              className="group border-t border-hairline"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-left [&::-webkit-details-marker]:hidden">
                <h3 className="text-base font-medium text-ink-900 sm:text-lg">
                  {q}
                </h3>
                <ChevronDown
                  aria-hidden="true"
                  className="size-5 shrink-0 text-ink-400 transition-transform duration-300 group-open:rotate-180"
                />
              </summary>
              {typeof a === 'string' ? (
                <p className={answerClassName}>{a}</p>
              ) : (
                <div className={answerClassName}>{a}</div>
              )}
            </details>
          ))}
        </div>
        <p className="mt-8 text-sm leading-relaxed text-ink-500">
          Read the{' '}
          <a
            href={links.docs}
            className="underline underline-offset-4 hover:text-ink-900"
          >
            Den product documentation
          </a>
          , including{' '}
          <a
            href={`${links.docs}/smart-contracts/deployments`}
            className="underline underline-offset-4 hover:text-ink-900"
          >
            supported EVM networks
          </a>{' '}
          and{' '}
          <a
            href={`${links.docs}/enterprise-security/disaster-recovery`}
            className="underline underline-offset-4 hover:text-ink-900"
          >
            recovery mechanisms and their permissions
          </a>
          .
        </p>
      </Container>
    </Section>
  );
}
